import { TnAClockingSTO } from "../../models/tna";
import { TnACounterDTO } from "../../models/tna/tna-counters/tna-counter-dto";
import { BaseApiService } from "../base/base-api.service";

export class TnAVacationTrackingsApiService extends BaseApiService<TnACounterDTO, TnAClockingSTO> {
  constructor() {
    super({
      servicePath: "/TnAOverviews",
      loadItemsPath: "/GetTnAVacationTrackings",
    });
  }
}
